<template>
<div class="container" style="margin: 0 auto"> 
    <vue-cal :selected-date="fecha_inicial"
             :time-from="7 * 60"
             :time-to="19 * 60"
             :disable-views="['years', 'year', 'month', 'week']"
             hide-weekends="false"
             :twelveHour="twelveHour"
             timeFormat="h:mm{am}"
             :timeCellHeight="cell_height"
             :min-event-width="minWodth"
             :SaturdaySunday=True 
             :all-day=True
             locale="es"
             :events="events" class="align-middle"   >
    </vue-cal>
</div>
    
</template>

<script>
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/i18n/es.js'
    import 'vue-cal/dist/vuecal.css'
    export default {
        name: "cta-calendar",
        components: {
            VueCal
        },
        data: () => ({
            twelveHour: true,
            minWodth: 0
        }),
        props: ["events", "fecha_inicial", "cell_height"],
    }
</script>

<style >
    .vuecal__event-title { font-weight: bold; font-size: 18px }
    .vuecal__event-time { font-size: 17px; }
    .vuecal__title-bar { font-size: 25px; background-color: #e4f5ef;}
    .vuecal__menu { font-size: 21px; color: white; background-color: var(--theme-color);}
    .vuecal__event { font-size: 17px;}
    .vuecal__no-event {display: none;}
    .vuecal__time-cell-label{font-size: 14px;color: #000;}

    .vuecal__event.taller {background-color: rgba(253, 156, 66, 0.85);border: 1px solid rgb(233, 136, 46);color: #000;}
    .vuecal__event.inaguracion {background-color: rgba(164, 230, 210, 0.9);border: 1px solid rgb(144, 210, 190);color: #000;}
    .vuecal__event.magistral {background-color: rgba(255, 184, 111, 0.7);border: 1px solid rgb(255, 184, 111);color: #000;}
    .vuecal__event.ponencias {background-color: rgba(255,228,225, 0.2);border: 1px solid rgb(255,228,225);color: #000;}
    .vuecal__event.panel {background-color: rgba(100, 200, 255, 0.8);border: 1px solid rgb(80, 180, 235);color: #000;}
    .vuecal__event.clausura {background-color: rgba(255, 200, 90, 0.75);border: 1px solid #ffc356;color: #000;}
    .vuecal__event.lunch {
        background: repeating-linear-gradient(45deg, transparent, transparent 10px, #f2f2f2 10px, #f2f2f2 20px);
        color: #999;
        display: flex;
        justify-content: center;
        align-items: center;
        vertical-align: middle;
    }
    .vuecal__event.lunch .vuecal__event-time {display: none;align-items: center;}
</style>
